import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-8 w-full border border-border bg-background px-2.5 py-1.5 text-sm',
          'placeholder:text-muted-foreground/60',
          'focus:outline-none focus:border-foreground focus:ring-1 focus:ring-foreground/20',
          'file:border-0 file:bg-transparent file:text-sm file:font-medium',
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted',
          '[&[type=number]]:tabular-nums [&[type=number]]:appearance-textfield',
          '[&[type=number]::-webkit-outer-spin-button]:appearance-none [&[type=number]::-webkit-inner-spin-button]:appearance-none',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
